module.exports = __webpack_public_path__ + "media/images/logo_navbar-6db7cc2f0cdd6b2f43f62d0c1271bb4d.png";